// extracted by mini-css-extract-plugin
module.exports = {"page":"GameAreaList_page__DlrX5","mainTable":"GameAreaList_mainTable__2mqNB"};